import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function WorkedHoursForAllAgentsReport() {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [agentWorkHours, setAgentWorkHours] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/allWorkedHours/${startDate}/${endDate}`);
            setAgentWorkHours(response.data);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по количеству отработанных часов каждого агента",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({
                            text: `Период: ${startDate} - ${endDate}`,
                        }),
                        ...Object.entries(agentWorkHours).map(([agentId, hours]) => [
                            new Paragraph({
                                text: `Идентификатор агента: ${agentId}`,
                            }),
                            new Paragraph({
                                text: `Отработанные часы: ${hours} часов`,
                            }),
                            new Paragraph({
                                text: "",
                            }),
                        ]).flat(),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "all_agents_worked_hours_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>📅 Отчет по часам за период</h2>

            <div className="otch-form-group">
                <label className="otch-form-label">Дата начала</label>
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="otch-form-input"
                />
            </div>

            <div className="otch-form-group">
                <label className="otch-form-label">Дата окончания</label>
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="otch-form-input"
                />
            </div>

            {agentWorkHours && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Отчет за период: <span className="otch-highlight">{startDate}</span> - <span className="otch-highlight">{endDate}</span>
                        <br />
                        Включено агентов: <span className="otch-highlight">{Object.keys(agentWorkHours).length}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading || !startDate || !endDate}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "📊 Получить отчет"
                    )}
                </button>
                {agentWorkHours && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>
        </div>
    );
}

export default WorkedHoursForAllAgentsReport;